<template>
    <div>
        <Dialog v-model:visible="visible" :style="{ width: '450px' }" header="Add New Company Pool" :modal="true" @hide="$emit('hide-dialog', true)">
            <div class="p-fluid">
                <div class="field">
                    <label for="name">Name</label>
                    <InputText maxlength = "255" id="name" :class="{ 'p-invalid': submitted && !pool.name }" v-model="pool.name" placeholder="Enter a pool name" />
                    <small v-if="submitted && !pool.name" class="p-invalid">Pool Name is mandatory.</small>
                </div>
                <div class="field">
                    <label for="description">Description:</label>
                    <Textarea id="description" v-model="pool.description" rows="3" />
                </div>
            </div>
            <template #footer>
                <div class="justify-content-end">
                    <Button label="Cancel" icon="pi pi-times" class="p-button-danger" @click="emit('hide-dialog')" />
                    <Button label="Submit" icon="pi pi-check" class="ml-2 p-button-primary" @click="submit" />
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue';
import { usePoolStore } from '../store';
import { storeToRefs } from 'pinia';

const emit = defineEmits(['hide-dialog']);
const props = defineProps({
    mode: {
        type: String,
        default: 'add',
    },
});

const store = usePoolStore();
const { pool } = storeToRefs(store);

const visible = ref(true);
const submitted = ref(false);

const submit = async () => {
    submitted.value = true;
    if (isValid()) {
        const response = props.mode == 'edit' ? await store.updatePool(pool.value?.id, pool.value) : await store.createPool(pool.value);
        if (response) {
            submitted.value = false;
            emit('hide-dialog', true);
        }
    }
};

const isValid = () => {
    if (!pool.value.name) {
        return false;
    }
    return true;
};
</script>
